import { render, staticRenderFns } from "./FileAdd.vue?vue&type=template&id=7894ffe8&"
import script from "./FileAdd.vue?vue&type=script&lang=js&"
export * from "./FileAdd.vue?vue&type=script&lang=js&"
import style0 from "./FileAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports